import axios from 'axios';
import { API_BACKOFFICE_SCHOOLS } from '../../services/api/apiConst';
import { manageObjectResponse } from './apiResponse';
import { getLogger } from '../logger';
import { PARAMS } from '../../const';

const debug = getLogger('services:api:schoolApi');

export let getSchool = (schoolId, customerId) => {
  if (schoolId) {
    const url = API_BACKOFFICE_SCHOOLS.replace(PARAMS.CUSTOMER, customerId).replace(PARAMS.SCHOOL, schoolId);
    return manageObjectResponse(axios.get(url));

    // TODO:I VER Q DEVUELVE ESTO CUANDO ENTRAS EN CLASE ONLINE PARA Q DIGA Q ES UNDEFINED
  }
  debug.error('[getSchool] school id is empty');
};
